import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'messageType' ? order : false}>
          <TableSortLabel
            active={orderBy === 'messageType'}
            direction={order}
            onClick={() => {
              onRequestSort('messageType');
            }}
          >
            種別
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'message' ? order : false}>
          <TableSortLabel
            active={orderBy === 'message'}
            direction={order}
            onClick={() => {
              onRequestSort('message');
            }}
          >
            メッセージ
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={order}
            onClick={() => {
              onRequestSort('createdAt');
            }}
          >
            登録日時
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'status' ? order : false}>
          <TableSortLabel
            active={orderBy === 'status'}
            direction={order}
            onClick={() => {
              onRequestSort('status');
            }}
          >
            ステータス
          </TableSortLabel>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
